import React, { ChangeEvent, useContext } from 'react';
import { UploadFileButton } from '../../../common';
import { AppContext } from '../../../common/context/';
import { ContractorModel, EmployeeNodeModel } from '../../../models';
import { ResultIdentifications } from '../Workshift-scheduler/Index';
import GroupedEmployeesTree from './tree/GroupedEmployeesTree';

interface Props {
    isCollapseTree: boolean;
    searchTearm: string;
    isSelectAllEmployes: boolean;
    resultOfFilterByIdentifications: ResultIdentifications;
    treeEmployeesCopy: EmployeeNodeModel[];
    isLoadingTree: boolean;
    employeesFromTemplate: EmployeeNodeModel[];
    treeEmployees: EmployeeNodeModel[];
    isImportSchedulings: boolean;
    handlerResetProgramation: (inputElementId: string) => void;
    handleImportProgramation: (e: ChangeEvent<HTMLInputElement>) => void;
    handleSearchInput: ({ target }: ChangeEvent<HTMLInputElement>) => void;
    handleResetSearchTerm: () => void;
    setIsSelectAllEmployes: (state: boolean) => void;
    setIsCollapseTree: (state: boolean) => void;
    handleEmployeesSelectionChange: (selectedEmployees: EmployeeNodeModel[]) => void;
    handlerUploadFile: (e: ChangeEvent<HTMLInputElement>) => void;
    setResultOfFilterByIdentifications: (newState: ResultIdentifications) => void;
    setTreeEmployeesCopy: (treeCopy: EmployeeNodeModel[]) => void;
    handlerOpenIdentificationsModal: () => void;
    typeOfPerson: string;
    contractorSelected: ContractorModel | undefined;
}

/**
 * Este componente tiene toda la información respecto al filtrado del arbol, la seleccion de todos y uno a uno, importación de los archivos y toda la
 * Logica del renderizado
 * @param Props
 * @returns Componente con toda la logica y eventos que manejaran el arbol
 */

export const TreeEmployees = ({
    isCollapseTree,
    searchTearm,
    isSelectAllEmployes,
    employeesFromTemplate,
    isLoadingTree,
    treeEmployeesCopy,
    treeEmployees,
    resultOfFilterByIdentifications,
    isImportSchedulings,
    setResultOfFilterByIdentifications,
    setTreeEmployeesCopy,
    handleSearchInput,
    setIsCollapseTree,
    setIsSelectAllEmployes,
    handleResetSearchTerm,
    handleEmployeesSelectionChange,
    handlerUploadFile,
    handlerOpenIdentificationsModal,
    handlerResetProgramation,
    handleImportProgramation,
    typeOfPerson,
    contractorSelected,
}: Props) => {
    const { langResources } = useContext(AppContext);

    const handlerResetTree = () => {
        let input: HTMLInputElement = document.getElementById(
            'formFile'
        ) as HTMLInputElement;

        input.value = '';
        setResultOfFilterByIdentifications({
            status: false,
            employessFound: 0,
            employessNotFound: 0,
            identificationsNotFound: [],
        });
        setTreeEmployeesCopy(treeEmployees);
    };

    return (
        <div
            className={`tree_employees ${
                isCollapseTree && 'tree_employees--active'
            }`}
        >
            <div className='employees__sidebar'>
                <div className={!isCollapseTree ? 'tree_employees--wrapper' : ''}>
                    <div className='d-flex gap-2 align-items-center justify-content-center'>
                        <div
                            className={`pe-2 p-lg-1 d-flex justify-content-center  align-items-center  gap-1 ${
                                isCollapseTree ? 'visually-hidden' : ''
                            }`}
                        >
                            <div
                                className={`form-check d-flex  gap-1 align-items-center mt-2 checked-custom
                                `}
                            >
                                {isSelectAllEmployes ? (
                                    <label
                                        htmlFor='selectAllEmployes'
                                        style={{ fontSize: 18, paddingLeft: 5 }}
                                    >
                                        <i
                                            className={`ri-checkbox-multiple-line checked-custom text-primary2
                                            `}
                                        ></i>
                                    </label>
                                ) : (
                                    <label
                                        htmlFor='selectAllEmployes'
                                        style={{ fontSize: 18, paddingLeft: 5 }}
                                    >
                                        <i className='ri-checkbox-multiple-blank-line '></i>
                                    </label>
                                )}
                                <input
                                    className='form-check-input d-none'
                                    type='checkbox'
                                    checked={isSelectAllEmployes}
                                    onChange={(e) =>
                                        setIsSelectAllEmployes(!isSelectAllEmployes)
                                    }
                                    id='selectAllEmployes'
                                />
                                <label htmlFor='selectAllEmployes'>
                                    {langResources['header.type.all']}
                                </label>
                            </div>

                            <div
                                style={{
                                    background: '#fff',
                                    position: 'relative',
                                }}
                            >
                                <i
                                    className='ri-search-line'
                                    style={{
                                        position: 'absolute',
                                        top: '25%',
                                        left: '10px',
                                        color: '#9F9FA0',
                                    }}
                                ></i>
                                <input
                                    name='search'
                                    placeholder={
                                        langResources['create.workshift.Modal'][
                                            'search'
                                        ] + '...'
                                    }
                                    onChange={(e) => handleSearchInput(e)}
                                    type='text'
                                    value={searchTearm}
                                    className='form-control form-control w-100 text-dark'
                                    style={{
                                        background: 'transparent',
                                        paddingLeft: '25px',
                                        fontSize: '11px',
                                    }}
                                    autoSave={'false'}
                                    autoComplete={'false'}
                                />
                                {searchTearm.trim().length > 0 && (
                                    <span
                                        className='mdi mdi-close-circle search-widget-icon search-widget-icon-close'
                                        id='search-close-options'
                                        onClick={handleResetSearchTerm}
                                        style={{
                                            position: 'absolute',
                                            right: 10,
                                            top: '20%',
                                            fontSize: 12.5,
                                            color: '#9F9FA0',
                                            cursor: 'pointer',
                                        }}
                                    ></span>
                                )}
                            </div>
                        </div>

                        <i
                            className={`d-none d-lg-block ri-pushpin-${
                                isCollapseTree ? 'line' : '2-line'
                            } fs-4 text-muted p-1`}
                            style={{ cursor: 'pointer', fontSize: 12.5 }}
                            onClick={(e) => setIsCollapseTree(!isCollapseTree)}
                        ></i>
                    </div>
                </div>

                <div
                    className={`card-body p-lg-1 tree__container ${
                        resultOfFilterByIdentifications.status
                            ? 'tree__container--small'
                            : ''
                    } ${isCollapseTree ? 'visually-hidden' : ''}`}
                >
                    <GroupedEmployeesTree
                        onSelectionChange={handleEmployeesSelectionChange}
                        employees={treeEmployeesCopy}
                        isLoading={isLoadingTree}
                        isSelectAllEmployes={isSelectAllEmployes}
                        employeesFromTemplate={employeesFromTemplate}
                        searchValue={searchTearm}
                        typeOfPerson={typeOfPerson}
                        contractorSelected={contractorSelected}
                    />
                </div>

                <div
                    className={`d-none d-lg-flex card-footer p-1 gx-1  row ${
                        isCollapseTree ? 'visually-hidden ' : ''
                    }`}
                >
                    <div className='col-9'>
                        <UploadFileButton
                            isFileUploaded={resultOfFilterByIdentifications.status}
                            inputId='formFile'
                            handlerResetProgramation={handlerResetTree}
                            buttonTitle={
                                langResources['tree.deleted.employees.list.btn']
                            }
                            buttonIconTitle={'mdi mdi-file-remove fs-3'}
                            bgButtonColor='btn-outline-danger btn-small w-100'
                            bgLabelColor={`btn-primary btn-small`}
                            labelTitle={''}
                            labelIconTitle={'ri-file-upload-line fs-3'}
                            showText={false}
                            title={langResources['tree.identifications.import']}
                            titleRemove={
                                langResources['tree.identifications.delete.import']
                            }
                        />

                        <input
                            id='formFile'
                            type='file'
                            className='text-dark form-control form-control form-control-sm mt-1 d-none'
                            multiple={false}
                            onChange={handlerUploadFile}
                        />

                        {resultOfFilterByIdentifications.status ? (
                            <div>
                                <p className='mt-2'>
                                    {langResources['tree.employees.found.title']}
                                    {': '}
                                    <span className='fw-bold'>
                                        {
                                            resultOfFilterByIdentifications.employessFound
                                        }
                                    </span>
                                </p>
                                <p
                                    onClick={handlerOpenIdentificationsModal}
                                    style={{
                                        marginTop: '-15px',
                                        textDecoration: 'underline',
                                        cursor: 'pointer',
                                    }}
                                >
                                    {langResources['tree.employees.not.found.title']}
                                    {': '}
                                    <span className='fw-bold'>
                                        {
                                            resultOfFilterByIdentifications.employessNotFound
                                        }
                                    </span>
                                </p>
                            </div>
                        ) : (
                            <></>
                        )}
                    </div>

                    <div className='col-3'>
                        <UploadFileButton
                            isFileUploaded={isImportSchedulings}
                            inputId='form-import-template'
                            handlerResetProgramation={handlerResetProgramation}
                            buttonTitle={'Eliminar Archivo'}
                            buttonIconTitle={'mdi mdi-file-remove fs-4'}
                            bgButtonColor='btn-light btn-small'
                            bgLabelColor='btn-outline-success btn-small'
                            labelTitle={langResources['header.syncExcel']}
                            labelIconTitle={'ri-file-excel-2-fill fs-4'}
                            showText={false}
                            title={langResources['header.syncExcel']}
                            titleRemove={langResources['header.remove.syncExcel']}
                            isImage={true}
                            sourceImg={'./assets/images/clearScreen-dark.svg'}
                        />

                        <input
                            id='form-import-template'
                            type='file'
                            className='text-dark form-control form-control form-control-sm mt-1 d-none'
                            multiple={false}
                            onChange={handleImportProgramation}
                        />
                    </div>
                </div>
            </div>

            {isCollapseTree && (
                <div
                    className='collapse__sidebar'
                    onClick={(e) => setIsCollapseTree(!isCollapseTree)}
                >
                    <p className='collapse__text fs-2 text-center'>
                        <i className={`ri-list-check-2 text-primary2`}></i>
                    </p>
                </div>
            )}
        </div>
    );
};
